<template>
  <v-container fluid class="pa-6">
    <v-row align="center" class="mb-4">
      <v-col cols="12" md="4">
        <h1 class="text-h4 font-weight-bold" style="color: #1976d2">
          <v-icon large color="primary" class="mr-2">mdi-office-building</v-icon>
          Gestión de Empresas
        </h1>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="search"
          label="Buscar empresa..."
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          density="comfortable"
          hide-details
          clearable
          @keyup.enter="page = 1; loadCompanys()"
          @click:clear="search = ''; page = 1; loadCompanys()"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="filtroCiudad"
          label="Ciudad"
          prepend-inner-icon="mdi-city"
          variant="outlined"
          density="comfortable"
          hide-details
          clearable
          @keyup.enter="page = 1; loadCompanys()"
          @click:clear="filtroCiudad = ''; page = 1; loadCompanys()"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="filtroPais"
          label="País"
          prepend-inner-icon="mdi-earth"
          variant="outlined"
          density="comfortable"
          hide-details
          clearable
          @keyup.enter="page = 1; loadCompanys()"
          @click:clear="filtroPais = ''; page = 1; loadCompanys()"
        />
      </v-col>
      <v-col cols="12" md="1" class="d-flex justify-end">
        <v-pagination
          v-model="page" 
          :length="totalPages"
          :total-visible="5"
          density="comfortable"
          active-color="primary"
          @update:model-value="loadCompanys"
        />
      </v-col>
    </v-row>

    <v-card elevation="2" class="rounded-lg">
      <v-table hover>
        <thead class="bg-blue text-white">
          <tr>
            <th class="text-white">ID</th>
            <th class="text-white">Empresa</th>
            <th class="text-white">Ciudad/País</th>
            <th class="text-white">Celular</th>
            <th class="text-white">Vistas</th>
            <th class="text-white text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="company in companys" :key="company.idCompany">
            <td class="font-weight-bold">#{{ company.idCompany }}</td>
            
            <td>
              <v-chip size="small" variant="outlined" color="primary">
                {{ company.company }}
              </v-chip>
            </td>
            
            <td>{{ company.city }}, {{ company.country }}</td>
            
            <td>{{ company.phone }}</td>
            
            <td>
              <v-chip color="blue-darken-2" size="x-small" label>
                {{ company.views }} visitas
              </v-chip>
            </td>
            
            <td class="text-center">
              <v-btn 
                icon="mdi-gift" 
                variant="text" 
                color="purple-darken-1" 
                size="small" 
                title="Regalar Hospedaje"
                @click="openGiftModal(company)"
              />
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>

    <v-row class="mt-6">
      <v-col cols="12" class="d-flex justify-center">
        <v-pagination 
          v-model="page" 
          :length="totalPages" 
          :total-visible="7" 
          active-color="green" 
          @update:model-value="loadCompanys"
        />
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="700px" persistent>
      <v-card class="rounded-lg">
        <v-toolbar color="primary" title="Editar Información de Empresa" density="compact">
          <v-btn icon="mdi-close" @click="dialog = false"></v-btn>
        </v-toolbar>
        
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedCompany.empresa" label="Nombre de la Empresa" variant="outlined" density="comfortable"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedCompany.celular" label="Teléfono de Contacto" variant="outlined" density="comfortable"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedCompany.pais" label="País" variant="outlined" density="comfortable"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedCompany.ciudad" label="Ciudad" variant="outlined" density="comfortable"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="editedCompany.ubicacion" label="Ubicación (Dirección/Link)" variant="outlined" density="comfortable"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="editedCompany.descripcion" label="Descripción del Negocio" variant="outlined" density="comfortable" rows="3"></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedCompany.vistas" label="Contador de Vistas" variant="outlined" density="comfortable" type="number" readonly></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey-darken-1" variant="text" @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" variant="elevated" :loading="loading" @click="saveCompany">Guardar Cambios</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000">
      {{ snackbar.text }}
    </v-snackbar>
    <v-dialog v-model="giftDialog" max-width="500px">
      <ComponentNewHostFree 
        :company="selectedCompany" 
        @close="giftDialog = false" 
        @success="onGiftSuccess" 
      />
    </v-dialog>
  </v-container>
</template>

<script>
import apisCompanys from '@/apis/apisCompanys';
import ComponentNewHostFree from '@/components/ComponentNewHostFree.vue';

export default {
  name: 'AllCompanysView',
  components: {
    ComponentNewHostFree,
  },
  data() {
    return {
      companys: [],
      search: "",
      filtroCiudad: "",
      filtroPais: "",
      page: 1,
      totalPages: 0,
      totalElements: 0,
      dialog: false,
      loading: false,
      editedCompany: {},
      snackbar: { show: false, text: '', color: '' },
      giftDialog: false,
      selectedCompany: {},
    };
  },
  mounted() {
    this.loadCompanys();
  },
  methods: {
    loadCompanys() {
      const pageIndex = this.page - 1;
      
      apisCompanys.searchAll(this.search, pageIndex, this.filtroPais, this.filtroCiudad)
        .then((response) => {
        // Como el backend devuelve un Page de Spring, usamos .content
        this.companys = response.content; 
        this.totalPages = response.totalPages;
        this.totalElements = response.totalElements;
        })
        .catch((error) => {
            console.error("Error en la API de Bahiol:", error);
            this.showNotify("No se pudo conectar con el servidor", "error");
        });
    },
    
    openGiftModal(company) {
      this.selectedCompany = company;
      this.giftDialog = true;
    },
    
    viewDetails(company) {
      // Ajusta 'SiteDetail' al nombre de tu ruta
      this.$router.push({ name: 'SiteDetail', params: { id: company.idEmpresa } });
    },
    
    showNotify(text, color) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    }
  }
};
</script>
<style scoped>
.border-rounded {
  border-radius: 16px !important;
}

.search-principal {
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

/* Estilo para que las filas se sientan más interactivas */
:deep(.v-data-table__tr:hover) {
  background-color: #f8f9fa !important;
}
</style>